import { MOCK_ADDRESS } from './MockAddress'

export const MOCK_CONTACT = {
  _created_at: '2025-04-04T09:18:17.430Z',
  _id: '6d0ce8f8-8b03-4bda-b22b-c9b829bb08fc',
  _org: 'test-org',
  _schema: 'contact',
  _title: 'Max Spark',
  _updated_at: '2025-06-12T06:03:13.192Z',
  address: [MOCK_ADDRESS],
  birthdate: '1982-09-01',
  consent_email_marketing: {
    identifiers: [
      {
        identifier: 'maxspark360@gmail.com',
        status: 'active'
      }
    ],
    status: 'active'
  },
  consent_phone_call: {
    identifiers: [
      {
        identifier: '012341234123',
        status: 'active'
      }
    ],
    status: 'active'
  },
  consent_print_marketing: {
    identifiers: [
      {
        identifier: '6d0ce8f8-8b03-4bda-b22b-c9b829bb08fc',
        status: 'unknown'
      }
    ],
    status: 'unknown'
  },
  consent_sms_marketing: {
    identifiers: [
      {
        identifier: '012341234123',
        status: 'active'
      }
    ],
    status: 'active'
  },
  customer_number: '1234567880',
  email: [
    {
      _id: 'HfAOh-AdruvBugA1FbjQf',
      email: 'maxspark360@gmail.com',
      id: 'q37xcz3'
    }
  ],
  first_ecp_login: '2025-04-04T13:56:15.807Z',
  first_name: 'Max',
  inbetriebnahme: false,
  journey_actions: [],
  language: 'en',
  last_name: 'Spark',
  payment: [
    {
      _id: 'UvxxbZ13mCnwchDZxheL8',
      _tags: [],
      data: {
        bank_name: 'ING-DiBa',
        bic_number: 'INGDDEFFXXX',
        consent: true,
        fullname: 'Max Spark',
        iban: 'DE02500105170137075030',
        start_date: '2025-01-01'
      },
      id: 'eb4tss8',
      type: 'payment_sepa'
    }
  ],
  phone: [
    {
      _id: 'UAa6m3SewPKOWJJXTXC3G',
      id: 'ewodw6a',
      phone: '012341234123'
    }
  ],
  salutation: 'Mr.'
}
